import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { setAppCustomTitle } from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import Loading from '../../Common/Loading';

const HeatmapChart = ({ chartData = [], Loader = true, defaultChartConfig = {}, tooltipLabel = "" }) => {
    const [chartOptionData, setChartOptionData] = useState({});
    const [chartSeriesData, setChartSeriesData] = useState([]);
    const [chartLabel, setChartLabel] = useState("");
    const [chartHeight, setChartHeight] = useState();
    const [chartWidth, setChartWidth] = useState();  
    const colorRanges = [
        { from: 76, to: 100, className: "theme-100p-color" },
        { from: 51, to: 75, className: "theme-75p-color" },
        { from: 26, to: 50, className: "theme-50p-color" },
        { from: 1, to: 25, className: "theme-25p-color" },
        { from: -3, to: 0.09, className: "theme-0p-color" }
    ];
    useEffect(() => {
        if (chartData && defaultChartConfig && tooltipLabel) {
            setDataForChart(chartData, defaultChartConfig, tooltipLabel);
        }
    }, [chartData, defaultChartConfig, tooltipLabel]);
    const highlightHeatmap = (range) => {
        document.querySelectorAll('.apexcharts-heatmap-rect').forEach((el) => {
          const value = parseFloat(el.getAttribute('val'));
          if (value >= range.from && value <= range.to) {
            el.style.stroke = '#000';
            el.style.strokeWidth = '2px';
          } else {
            el.style.opacity = '0.2';
          }
        });
      };
      
      const resetHeatmapHighlight = () => {
        document.querySelectorAll('.apexcharts-heatmap-rect').forEach((el) => {
          el.style.opacity = '';
          el.style.stroke = '';
          el.style.strokeWidth = '';
        });
      };

    setTimeout(() => {
    
        document.querySelectorAll('.apexcharts-heatmap-rect').forEach(el => {
            const value = parseFloat(el.getAttribute('val')); // Get heatmap value
            const range = colorRanges.find(r => value >= r.from && value <= r.to); // Find matching range
    
            if (range) {
                el.classList.add(range.className); // Assign class based on range
            }
        });
    }, 300);   
    
    const setDataForChart = (chartData, defaultChartConfig, tooltipLabel) => {
        let { type, toolbar, tooltipName, colorRange, height, width} = defaultChartConfig;
        if (!chartData[0] || !chartData[1] || !chartData[3]) {
            return;
        }
        let label = chartData[0] || [];
        let series = chartData[1]; 
        //let tooltipData = chartData[3]; 
        let tooltipFormat = {};
        if (tooltipName === "callHeatMap") {
            tooltipFormat = {
                enabled: true,
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    let value = series[seriesIndex][dataPointIndex];
                    let matchedRange = colorRange?.find(range => value >= range.from && value <= range.to);
                    let backgroundColor = matchedRange ? matchedRange.color : '#FFFFFF';
                    let category = w.config.xaxis.categories[dataPointIndex];
                    let totalCalls =w.config.tooltipData[seriesIndex]?.[dataPointIndex]?.[0] || 0;
                    let calls = w.config.tooltipData[seriesIndex]?.[dataPointIndex]?.[1] || 0;
                    let label = w.config.tooltipLabel;
                    return `
                        <div class="cus-tooltip-box">
                            <div class="cus-tooltip-header">
                                <strong>${label}</strong>
                                <span style="background-color: ${backgroundColor}; width: 15px; height: 15px; display: inline-block; margin-left: 8px; border-radius:50%;"></span>
                            </div>
                            <div class="cus-tooltip-body">
                                <span>Time: ${category}</span><br>
                                <span>Total Calls: ${totalCalls}</span><br>
                                <span>${label}: ${calls} (${value}%)</span><br>
                            </div>
                        </div>
                    `;
                },
            };
        }

        let options = {
            chart: {
                type: type || 'heatmap',
                toolbar: { show: !!toolbar },
            },
            plotOptions: {
                heatmap: {
                    shadeIntensity: 0.5,
                    radius: 8,
                },
            },
            states: {
                hover: {
                  filter: {
                    type: 'darken', // or 'lighten'
                    value: 0.6,     // intensity
                  }
                }
            },
            legend:{
                show:true,
                showForSingleSeries:true,
            },
            xaxis: {
                categories: label || [],
            },
            dataLabels: {
                enabled: true,
                formatter: function (value) {
                    return value === 0 ? '0%' : `${value}%`; 
                },
            },
            tooltip: tooltipFormat,
            tooltipData: chartData[3] || [],
            tooltipLabel : tooltipLabel.slice(tooltipLabel.indexOf('vs') + 3).trim()
        };

        setChartOptionData(options);
        setChartSeriesData(series);
        setChartLabel(tooltipLabel);
        setChartWidth(width);
        setChartHeight(height);
    };

    return (
        <div>
            <Loading
                showLoader={
                    Loader
                }
                mainContent={
                    <>
                        <div className="card widget-chart text-start">
                            <div className="widget-chart-content">
                                <span className="widget-subheading">{chartLabel}</span>
                                <div className="heatmap-legend d-flex flex-wrap mt-3 justify-content-center">
                                    {colorRanges.map((range, index) => (
                                        <div
                                        className="legend-item d-flex align-items-center"
                                        key={index}
                                        onMouseEnter={() => highlightHeatmap(range)}
                                        onMouseLeave={resetHeatmapHighlight}
                                        >
                                            <span className={`legend-color ${range.className}`}></span>
                                            <span className='me-3'>{range.to === 0.09 ? 0 : range.to} - {range.from === -3 ? 0.09 : range.from }%</span>
                                        </div>
                                    ))}
                                </div>
                                <ReactApexChart
                                    options={chartOptionData}
                                    series={chartSeriesData}
                                    type="heatmap"
                                    height={chartHeight}
                                    width={chartWidth}
                                />
                            </div>
                        </div>
                    </>
                }
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle,
});

const mapDispatchToProps = (dispatch) => ({
    setAppCustomTitle: (title) => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeatmapChart);
